<template>
    <div>

        <b-dropdown
            v-if="$store.getters['costable/isEditable']"
            right
            size="sm"
            :disabled="isTableLoading"
        >
            <template slot="button-content">
                <i class="fa fa-fw fa-plus" />
                <span class="mx-1">Add</span>
                <i class="fa fa-fw fa-caret-down" />
            </template>
            <b-dropdown-header>Add to Cost</b-dropdown-header>
            <b-dropdown-item @click="openAddCostModal">
                <i class="fa fa-fw fa-plus" />
                <span class="ml-2">Add Cost</span>
            </b-dropdown-item>
            <b-dropdown-item @click="openAddGroupModal">
                <i class="fa fa-fw fa-plus" />
                <span class="ml-2">Add Group</span>
            </b-dropdown-item>
            <b-dropdown-item @click="openAddPackageModal">
                <i class="fa fa-fw fa-plus" />
                <span class="ml-2">Add Package</span>
            </b-dropdown-item>
            <b-dropdown-item
                v-if="canHaveContingency && hasContingency"
                @click="openEditContingencyModal"
            >
                <i class="fa fa-fw fa-pencil" />
                <span class="ml-2">Edit Contingency</span>
            </b-dropdown-item>
            <b-dropdown-item
                v-else-if="canHaveContingency"
                @click="openAddContingencyModal"
            >
                <i class="fa fa-fw fa-plus" />
                <span class="ml-2">Add Contingency</span>
            </b-dropdown-item>
            <b-dropdown-item
                v-if="canHaveServiceCharge"
                @click="openServiceChargeModal"
            >
                <i class="fa fa-fw fa-plus" />
                <span class="ml-2">{{ hasServiceCharge ? 'Edit' : 'Add' }} {{ $t('cost.service_charge') }}</span>
            </b-dropdown-item>
        </b-dropdown>

        <b-dropdown
            v-if="hasLinks"
            right
            size="sm"
            :disabled="isTableLoading"
        >
            <template slot="button-content">
                <i class="fa fa-fw fa-download" />
                <span class="mx-1">Export</span>
                <i class="fa fa-fw fa-caret-down" />
            </template>
            <b-dropdown-header>Save/Export Cost</b-dropdown-header>
            <b-dropdown-item
                v-if="!!saveAsQuoteLink"
                :href="saveAsQuoteLink"
            >
                <i class="fa fa-fw fa-save" />
                <span class="ml-2">Save as Quote</span>
            </b-dropdown-item>
            <b-dropdown-item
                v-if="!!exportSummaryPdfUrl"
                @click="openExportSummaryPdfModal"
            >
                <i class="fa fa-fw fa-download" />
                <span class="ml-2">Export Summary PDF</span>
            </b-dropdown-item>
            <b-dropdown-item
                v-if="!!exportToExcelLink"
                :href="exportToExcelLink"
            >
                <i class="fa fa-fw fa-download" />
                <span class="ml-2">Export to Excel</span>
            </b-dropdown-item>
            <b-dropdown-item
                v-if="!!exportCostsOnlyLink"
                :href="exportCostsOnlyLink"
            >
                <i class="fa fa-fw fa-download" />
                <span class="ml-2">Export costs</span>
            </b-dropdown-item>
        </b-dropdown>

        <b-button
            v-if="$store.getters['costable/isEditable']"
            size="sm"
            @click="openImportModal"
        >
            <i class="fa fa-fw fa-upload" />
            <span class="mx-1">Import</span>
        </b-button>

    </div>
</template>

<script>
export default {

    computed: {
        costable() {
            return this.$store.getters['costable/costable'];
        },
        saveAsQuoteLink() {
            return this.costable.links.save_as_quote;
        },
        exportSummaryPdfUrl() {
            return this.costable.links.export_summary_pdf;
        },
        exportToExcelLink() {
            return this.costable.links.export_to_excel;
        },
        exportCostsOnlyLink() {
            return this.costable.links.export_costs_only;
        },
        openPdfsInNewTab() {
            return this.$store.getters['costable/shouldOpenPdfsInNewTab'];
        },
        hasLinks() {
            return !!this.saveAsQuoteLink || !!this.exportToExcelLink;
        },
        canHaveContingency() {
            return this.$store.getters['costable/canHaveContingency'];
        },
        canHaveServiceCharge() {
            return this.$store.getters['costable/canHaveServiceCharge'];
        },
        hasServiceCharge() {
            return this.$store.getters['costable/hasServiceCharge'];
        },
        hasContingency() {
            return this.$store.getters['costable/hasContingency'];
        },
        isTableLoading() {
            return this.$store.getters['costable/isCostableTableLoading'];
        },
    },

    methods: {
        openAddCostModal() {
            this.$eventBus.$emit(this.$events.openAddCostModal, {});
        },
        openAddGroupModal() {
            this.$eventBus.$emit(this.$events.openAddGroupModal);
        },
        openAddPackageModal() {
            this.$eventBus.$emit(this.$events.openAddPackageModal);
        },
        openServiceChargeModal() {
            this.$eventBus.$emit(this.$events.openServiceChargeModal);
        },
        openAddContingencyModal() {
            this.$eventBus.$emit(this.$events.openAddContingencyModal);
        },
        openEditContingencyModal() {
            this.$eventBus.$emit(this.$events.openEditContingencyModal);
        },
        openExportSummaryPdfModal() {
            this.$eventBus.$emit(this.$events.openExportSummaryPdfModal, {
                url: this.exportSummaryPdfUrl,
                openInNewTab: this.openPdfsInNewTab,
            });
        },
        openImportModal() {
            this.$eventBus.$emit(this.$events.openImportModal);
        },
    },

};
</script>
